import { axiosClient } from "./axiosClient";

const contactApis = {
  createContact: (params: any) => axiosClient.post<any>(`/api/contact/`, params),
};
export default contactApis;
